import { logoSrc } from "@/components/BrandLogo";

export function BrandHeader({ branding, title, description }) {
  const b = branding || {};
  const details = [b.address, b.phone, b.email, b.website, b.registration].filter(Boolean);
  return (
    <div data-testid="form-brand-header" className="bg-white border border-zinc-200 rounded-lg overflow-hidden">
      <div className="h-1.5 bg-amber-500" />
      <div className="p-4 flex items-start justify-between gap-4">
        <div className="min-w-0">
          {b.logo_url && <img src={logoSrc(b.logo_url)} alt={b.company_name} className="h-9 max-w-[160px] object-contain mb-1.5" />}
          <div className="font-heading font-bold text-slate-900 text-sm">{b.company_name}</div>
        </div>
        {details.length > 0 && <div className="text-[11px] text-zinc-500 text-right leading-relaxed">{details.map((d) => <div key={d}>{d}</div>)}</div>}
      </div>
      {title && (
        <div className="px-4 pb-4">
          <h1 className="text-lg font-heading font-bold text-slate-900" data-testid="form-title">{title}</h1>
          {description && <p className="text-sm text-zinc-500 mt-0.5 whitespace-pre-line">{description}</p>}
        </div>
      )}
    </div>
  );
}
